import React from "react";
import Project from "../../../components/Project";
import data from "../../../components/data";
import Scrollchor from "react-scrollchor";

const projects = () => data.projects;
export default () => (
  <section id="projects" className="wrapper style1 special fade-up">
    <div className="container">
      <header className="major">
        <h2>Featured Work</h2>
        <p>
          Using the best-in-class technology, I build web apps and apps that
          perform.
        </p>
      </header>
      <div className="box alt">
        <div className="row gtr-uniform">
          {projects().map((project, i) => {
            return (
              <Project
                key={i}
                name={project.name}
                link={project.live}
                description={project.description}
                image={project.image}
                id={i}
              />
            );
          })}
          {/*<Project />*/}
          {/*<Project />*/}
          {/*<Project />*/}
        </div>
      </div>
      <footer className="major">
        <ul className="actions special">
          <li>
            <Scrollchor
                to={"#one"}
                className={"button"}
                animate={{offset: 20, duration: 600}}
            >
              Next
            </Scrollchor>
          </li>
        </ul>
      </footer>

    </div>
  </section>
);
